import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=4bf52af9&scoped=true"
import script from "./NoContent.vue?vue&type=script&lang=js"
export * from "./NoContent.vue?vue&type=script&lang=js"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=4bf52af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf52af9",
  null
  
)

export default component.exports